/* eslint-disable no-unused-vars */
import {
  ChevronLeft,
  ChevronRight,
  FirstPage,
  LastPage
} from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import PaginationItem from '@mui/material/PaginationItem';

export default function CustomPagination({
  count,
  page,
  onChange,
  maxPagesToShow = 5
}) {
  if (count <= 1) return null;

  const half = Math.floor(maxPagesToShow / 2);
  let start = Math.max(1, page - half);
  let end = start + maxPagesToShow - 1;

  if (end > count) {
    end = count;
    start = Math.max(1, end - maxPagesToShow + 1);
  }

  const pageNumbers = [];
  for (let i = start; i <= end; i++) {
    pageNumbers.push(i);
  }

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <IconButton disabled={page === 1} onClick={() => onChange(null, 1)}>
        <FirstPage fontSize="small" />
      </IconButton>
      <IconButton
        disabled={page === 1}
        onClick={() => onChange(null, page - 1)}
      >
        <ChevronLeft fontSize="small" />
      </IconButton>

      {pageNumbers.map((p) => (
        <PaginationItem
          key={p}
          page={p}
          selected={p === page}
          onClick={() => onChange(null, p)}
        />
      ))}

      <IconButton
        disabled={page === count}
        onClick={() => onChange(null, page + 1)}
      >
        <ChevronRight fontSize="small" />
      </IconButton>
      <IconButton
        disabled={page === count}
        onClick={() => onChange(null, count)}
      >
        <LastPage fontSize="small" />
      </IconButton>
    </Box>
  );
}
